import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

export interface VendorProductSupportRequest {
	productIds: string[];
}

export interface VendorProductSupportResponse {
	vendorId: string;
	productIds: string[];
}

@Injectable({
	providedIn: "root"
})
export class VendorSupportedProductsService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/", appConfigService.getConfigValue("API_ENDPOINT") as string);
	}

	getForSelf(): Observable<VendorProductSupportResponse> {
		return this.api.getAndThrowError<VendorProductSupportResponse>(
			this.url("vendor/supported-products")
		);
	}

	putForSelf(
		body: VendorProductSupportRequest
	): Observable<VendorProductSupportResponse> {
		return this.api.putAndThrow<VendorProductSupportResponse>(
			this.url("vendor/supported-products"),
			body
		);
	}

	getForVendor(vendorId: string): Observable<VendorProductSupportResponse> {
		return this.api.getAndThrowError<VendorProductSupportResponse>(
			this.url(`admin/vendors/${vendorId}/supported-products`)
		);
	}

	putForVendor(
		vendorId: string,
		body: VendorProductSupportRequest
	): Observable<VendorProductSupportResponse> {
		return this.api.putAndThrow<VendorProductSupportResponse>(
			this.url(`admin/vendors/${vendorId}/supported-products`),
			body
		);
	}
}
